// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  text-decoration: none;

}
.content {
  padding: 20px;
}

.content__heading {
  margin-bottom: 20px;
  font-size: 2rem;
  color: #ffffff;
}

.resto {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 20px;
}
.restaurant-info {

  text-align: center; 
}

.card {
  background-color: #F3EEEA;
  border: 3px solid #B0A695;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 300px;
  height: 400px;
  max-width: 100%;
  max-height: 100%;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin: 20px 10px;
}

.card h3 {
  margin-bottom: 10px;
  font-size: 1.5rem;
  color: #333333;
}

.formname{
  height: 45px;
}

.menu-list,
.review-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

.menu-list li,
.review-list li {
  margin-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 5px;
}

.fav-resto {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 20px;
}

.fav-resto .card-fav {
  width: calc(33.33% - 40px);
  box-sizing: border-box;
}


.card-fav {
  background-color: #F3EEEA;
  border: 3px solid #B0A695;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 300px;
  height: 450px;
  max-width: 100%;
  max-height: 100%;
  display: inline-block;
  vertical-align: top;
  margin: 20px;
}

.card-detail {
  background-color: #F3EEEA;
  border: 3px solid #B0A695;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 12px 5px; 
  max-width: 100%;
  box-sizing: border-box; 
}
.card-detail-rev {
  background-color: #F3EEEA;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px 0;
  max-width: 100%;
  gap: 11px;
  box-sizing: border-box;
}

.card-detail {
  max-width: 100%; 
  width: calc(100% - 40px); 
}

.card-detail-rev {
  max-width: 100%;
  width: calc(100% - 40px); 
}

.card-fav .card-img {
  height: 180px;
}

.card-fav .rating {
  display: flex;
  align-items: center;
  color: #FFD700; 
  font-size: 1.2rem;
  margin-top: 10px;
}

.card-fav .rating i {
  margin-right: 5px;
}

.card-fav .rating .fa-star {
  color: #FFD700; 
}

.card-fav .rating .fa-star-half-alt,
.card-fav .rating .far {
  color: #CCCCCC; 
}

.card-fav .rating-text {
  color: #000000;
  font-size: 1rem;
  margin-left: 10px;
}

.card-fav .card-title a {
  color: #0c0c0c;
  text-decoration: none;
  font-size: 1.2rem;
  width: 66px;
  height: 48px;
}


.card-fav .card-title a:hover {
  color: #776B5D;
}

.card-fav .card-text {
  font-size: 1rem;
  margin-top: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}



.card-img {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 200px; 
}

.city-label {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 5px;
  border-radius: 5px;
}

.city-label-text {
  font-size: 12px;
}

.card-img img {
  width: 100%;
  height: 100%; 
  object-fit: cover;
  border-radius: 8px;
}

.card-body {
  padding: 10px 0;
}

.rating {
  display: flex;
  align-items: center;
  color: #FFD700;
  font-size: 1.2rem; 
  margin-bottom: 10px;
}

.rating i {
  margin-right: 5px;
}

header.app-bar {
  padding: 8px 16px;
  background-color: #776B5D;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  position: sticky;
  justify-content: space-between;
  top: 0;
  z-index: 99;
  box-shadow: #EBE3D5;
}

.app-bar__menu {
  display: flex;
  align-items: center;
}

.app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 24px;
  padding-right: 5em;
  padding: 8px;
  width: 44px;
  height: 44px;
  cursor: pointer;
  color: #F3EEEA;
}

.app-bar__menu button:hover {
  color: #ccc;
}

.app-bar__brand {
  display: flex;
  align-items: center;
  justify-content: end;
}

.app-bar__brand h1 {
  user-select: none;
  color: #F3EEEA;
  text-shadow:2px 2px 3px #B0A695;
  font-family: "Pacifico", cursive;
  letter-spacing: 3px;
  margin: 0;
}

.app-bar__navigation {
  position: absolute;
  top: 50px;
  left: -180px;
  width: 150px;
  transition: all 0.3s;
  padding: 8px;
  background-color: transparent;
  overflow: hidden;
}

.app-bar__navigation.open {
  background-color: #776B5D;
  left: 0;
}

.app-bar__navigation ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.app-bar__navigation ul li {
  margin-bottom: 5px;

}

.app-bar__navigation ul li a {
  font-size: 20px;
  font-weight: 500;
  display: inline-block;
  text-decoration: none;
  color: white;
  padding: 10px;
  width: 100%;
  position: relative;
  transition: color 0.3s;
}

.app-bar__navigation ul li a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: white;
  transition: width 0.3s;
}

.app-bar__navigation ul li a:hover::after {
  width: 100%;
}



.rating .fa-star {
  color: #FFD700;
}

.rating .fa-star-half-alt,
.rating .far {
  color: #CCCCCC;
}

.rating-text {
  color: #000000;
  font-size: 1rem;
  margin-left: 10px;
}

.card-title a {
  color: #0c0c0c;
  text-decoration: none;
  font-size: 1.5rem;
}

.card-title a:hover {
  color: #776B5D;
}

.card-text {
  font-size: 1rem;
  margin-top: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#restaurantDetailContainer h3 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #EBE3D5;
}


#restaurantDetailContainer p {
  font-size: 1rem;
  margin-bottom: 15px;
  color: #0c0c0c;
}

#restaurantDetailContainer img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

#likeButton,
#unlikeButton {
  background-color: #776B5D; 
  color: #ffffff; 
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  margin-top: 15px;
  margin-right: 8px;
  position: fixed; 
  bottom: 20px; 
  right: 20px; 
  z-index: 1000; 
  width: 55px;
  height: 45px;
}

#likeButton:focus,
#unlikeButton:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);
}

#likeButton:hover,
#unlikeButton:hover {
  background-color: #776B5D;
}

#likeButton:active,
#unlikeButton:active {
  background-color: #776B5D;
}
#restaurantDetailContainer {
  background-color: #F3EEEA;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

#restaurantDetailContainer h3 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333333;
}

#restaurantDetailContainer p {
  font-size: 1rem;
  margin-bottom: 15px;
  color: #555555;
}

#restaurantDetailContainer img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 20px;
}


.card {
  background-color: #F3EEEA;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 20px;
}

.card h3 {
  margin-bottom: 10px;
  font-size: 1.5rem;
  color: #333333;
}

.menu-list,
.review-list {
  list-style-type: none;
  padding: 0;
}

.menu-list li,
.review-list li {
  margin-bottom: 10px;
  border-bottom: 1px solid #EBE3D5;
  padding-bottom: 5px;
}

.review-list li:last-child {
  border-bottom: none;
}
#reviewForm {
  background-color: #FFFFFF;
  border: 2px solid #B0A695;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

#reviewForm h3 {
  margin-bottom: 15px;
  color: #333;
}

#reviewForm input[type="text"],
#reviewForm textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #B0A695;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
}

#reviewForm textarea {
  height: 100px;
  resize: vertical;
}

#reviewForm button[type="submit"] {
  background-color: #B0A695;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

#reviewForm button[type="submit"]:hover {
  background-color: #8A7F6F;
}


.review-list {
  list-style: none;
  padding: 0;
  margin: 20px 0 0 0;
}

.review-list li {
  background-color: #FFFFFF;
  border: 1px solid #B0A695;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  line-height: 1.5;
}

.review-list li::before {
  content: '•';
  color: #B0A695;
  font-weight: bold;
  display: inline-block; 
  width: 1em;
  margin-left: -1em;
}


.card-detail, .card-detail-rev {
  background-color: #F3EEEA;
  border: 3px solid #B0A695;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: inline-block;
  vertical-align: top;
  margin: 20px;
  max-width: 100%;
  box-sizing: border-box;
}
.menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
}

.menu h3 {
  grid-column: span 2;
}

.menu ul {
  list-style-type: none;
  padding: 0;
}

.menu li {
  margin-bottom: 10px;
}
header{
  background-color: #776B5D;
}



footer{
  display: flex;
  color: #F3EEEA;
  justify-content: space-around;
  text-align: center;
  align-items: center;
  height: 55px;
  background-color: #776B5D;
}

a{
 color: #F3EEEA;
}

body{
  font-family: "Rubik", sans-serif;
  background-color: #B0A695;
}

a, button, input[type="submit"], input[type="button"] {
  min-width: 44px;
  min-height: 44px;
  margin: 10px;
}

.navbar { 
  min-height: 70px;
  display: flex;
  justify-content: space-around;
  align-items: center;

}

.logo{
  color: #F3EEEA;
  text-shadow:2px 2px 3px #B0A695;
  font-family: "Pacifico", cursive;
  letter-spacing: 3px;
}

.nav-menu{
  display: flex;
  justify-content: space-between;
  align-self: center;
  gap: 60px;

}

.nav-link{
  transition: 0.5s ease;
  width: 74px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nav-link:hover{
  color: #0c0c0c;
}

#Bforom { 
  width: 90px;
  height: 44px;
  background-color: #776B5D; 
  color: #ffffff; 
}

button {
  background-color: transparent;
  border: none;
  font-size: 24px;
  padding: 8px;
  cursor: pointer;
  color: white;

  &:hover {
    color: #ccc;
  }
}

.bar {
  display: block;
  width: 28px;
  height: 3px;
  margin: 5px auto;
  border-radius: 3px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  background-color: rgb(11, 11, 11);
}

.hero {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100vh;
}

.hero img {
  width: 100%; 
  height: 100%; 
  object-fit: cover;
}

@media (min-width: 1200px) {
  .hero img {
    min-width: 1000px; 
  }
}



.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background-color: #776B5D ;
  color: white;
  padding: 8px;
  z-index: 100;
}
 
.skip-link:focus {
   top: 0;
   background-color: #B0A695 ;
}

.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  text-shadow: 3px 3px 4px #0b0b0b;
  color: rgb(255, 255, 255);
  padding: 0 20px
}

.hero-text h2 {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.hero-text p {
  font-size: 1.2rem;
}

.linkResto{
  display: inline-block;
  padding: 6px 12px;
  text-decoration: none;
  color: inherit;
}

.link:hover {
  background-color: rgba(0, 0, 0, 0.1);
}


.loading {
  display: none;
  text-align: center;
  font-size: 20px;
  color: #030303;
  margin-top: 20px;
}


.error {
  display: none;
  text-align: center;
  font-size: 18px;
  color: red;
  margin-top: 20px;
}

.loading .ri-loader-4-line {
  font-size: 2rem;
  display: block;
  margin: 0 auto;
  animation: spin 1s linear infinite;
}


@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;;AAEvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;;;AAIA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;;;AAIA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;;AAEX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;;EAEZ;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;GACG,MAAM;GACN,0BAA0B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;;AAGA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  list-style: none;\n  text-decoration: none;\n\n}\n.content {\n  padding: 20px;\n}\n\n.content__heading {\n  margin-bottom: 20px;\n  font-size: 2rem;\n  color: #ffffff;\n}\n\n.resto {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  grid-gap: 20px;\n}\n.restaurant-info {\n\n  text-align: center; \n}\n\n.card {\n  background-color: #F3EEEA;\n  border: 3px solid #B0A695;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 300px;\n  height: 400px;\n  max-width: 100%;\n  max-height: 100%;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin: 20px 10px;\n}\n\n.card h3 {\n  margin-bottom: 10px;\n  font-size: 1.5rem;\n  color: #333333;\n}\n\n.formname{\n  height: 45px;\n}\n\n.menu-list,\n.review-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.menu-list li,\n.review-list li {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #dddddd;\n  padding-bottom: 5px;\n}\n\n.fav-resto {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  grid-gap: 20px;\n}\n\n.fav-resto .card-fav {\n  width: calc(33.33% - 40px);\n  box-sizing: border-box;\n}\n\n\n.card-fav {\n  background-color: #F3EEEA;\n  border: 3px solid #B0A695;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 300px;\n  height: 450px;\n  max-width: 100%;\n  max-height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin: 20px;\n}\n\n.card-detail {\n  background-color: #F3EEEA;\n  border: 3px solid #B0A695;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin: 12px 5px; \n  max-width: 100%;\n  box-sizing: border-box; \n}\n.card-detail-rev {\n  background-color: #F3EEEA;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin: 20px 0;\n  max-width: 100%;\n  gap: 11px;\n  box-sizing: border-box;\n}\n\n.card-detail {\n  max-width: 100%; \n  width: calc(100% - 40px); \n}\n\n.card-detail-rev {\n  max-width: 100%;\n  width: calc(100% - 40px); \n}\n\n.card-fav .card-img {\n  height: 180px;\n}\n\n.card-fav .rating {\n  display: flex;\n  align-items: center;\n  color: #FFD700; \n  font-size: 1.2rem;\n  margin-top: 10px;\n}\n\n.card-fav .rating i {\n  margin-right: 5px;\n}\n\n.card-fav .rating .fa-star {\n  color: #FFD700; \n}\n\n.card-fav .rating .fa-star-half-alt,\n.card-fav .rating .far {\n  color: #CCCCCC; \n}\n\n.card-fav .rating-text {\n  color: #000000;\n  font-size: 1rem;\n  margin-left: 10px;\n}\n\n.card-fav .card-title a {\n  color: #0c0c0c;\n  text-decoration: none;\n  font-size: 1.2rem;\n  width: 66px;\n  height: 48px;\n}\n\n\n.card-fav .card-title a:hover {\n  color: #776B5D;\n}\n\n.card-fav .card-text {\n  font-size: 1rem;\n  margin-top: 10px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n\n\n.card-img {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  height: 200px; \n}\n\n.city-label {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #ffffff;\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.city-label-text {\n  font-size: 12px;\n}\n\n.card-img img {\n  width: 100%;\n  height: 100%; \n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.card-body {\n  padding: 10px 0;\n}\n\n.rating {\n  display: flex;\n  align-items: center;\n  color: #FFD700;\n  font-size: 1.2rem; \n  margin-bottom: 10px;\n}\n\n.rating i {\n  margin-right: 5px;\n}\n\nheader.app-bar {\n  padding: 8px 16px;\n  background-color: #776B5D;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  position: sticky;\n  justify-content: space-between;\n  top: 0;\n  z-index: 99;\n  box-shadow: #EBE3D5;\n}\n\n.app-bar__menu {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar__menu button {\n  background-color: transparent;\n  border: none;\n  font-size: 24px;\n  padding-right: 5em;\n  padding: 8px;\n  width: 44px;\n  height: 44px;\n  cursor: pointer;\n  color: #F3EEEA;\n}\n\n.app-bar__menu button:hover {\n  color: #ccc;\n}\n\n.app-bar__brand {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.app-bar__brand h1 {\n  user-select: none;\n  color: #F3EEEA;\n  text-shadow:2px 2px 3px #B0A695;\n  font-family: \"Pacifico\", cursive;\n  letter-spacing: 3px;\n  margin: 0;\n}\n\n.app-bar__navigation {\n  position: absolute;\n  top: 50px;\n  left: -180px;\n  width: 150px;\n  transition: all 0.3s;\n  padding: 8px;\n  background-color: transparent;\n  overflow: hidden;\n}\n\n.app-bar__navigation.open {\n  background-color: #776B5D;\n  left: 0;\n}\n\n.app-bar__navigation ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.app-bar__navigation ul li {\n  margin-bottom: 5px;\n\n}\n\n.app-bar__navigation ul li a {\n  font-size: 20px;\n  font-weight: 500;\n  display: inline-block;\n  text-decoration: none;\n  color: white;\n  padding: 10px;\n  width: 100%;\n  position: relative;\n  transition: color 0.3s;\n}\n\n.app-bar__navigation ul li a::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 0;\n  height: 2px;\n  background-color: white;\n  transition: width 0.3s;\n}\n\n.app-bar__navigation ul li a:hover::after {\n  width: 100%;\n}\n\n\n\n.rating .fa-star {\n  color: #FFD700;\n}\n\n.rating .fa-star-half-alt,\n.rating .far {\n  color: #CCCCCC;\n}\n\n.rating-text {\n  color: #000000;\n  font-size: 1rem;\n  margin-left: 10px;\n}\n\n.card-title a {\n  color: #0c0c0c;\n  text-decoration: none;\n  font-size: 1.5rem;\n}\n\n.card-title a:hover {\n  color: #776B5D;\n}\n\n.card-text {\n  font-size: 1rem;\n  margin-top: 10px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#restaurantDetailContainer h3 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n  color: #EBE3D5;\n}\n\n\n#restaurantDetailContainer p {\n  font-size: 1rem;\n  margin-bottom: 15px;\n  color: #0c0c0c;\n}\n\n#restaurantDetailContainer img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n#likeButton,\n#unlikeButton {\n  background-color: #776B5D; \n  color: #ffffff; \n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n  margin-top: 15px;\n  margin-right: 8px;\n  position: fixed; \n  bottom: 20px; \n  right: 20px; \n  z-index: 1000; \n  width: 55px;\n  height: 45px;\n}\n\n#likeButton:focus,\n#unlikeButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);\n}\n\n#likeButton:hover,\n#unlikeButton:hover {\n  background-color: #776B5D;\n}\n\n#likeButton:active,\n#unlikeButton:active {\n  background-color: #776B5D;\n}\n#restaurantDetailContainer {\n  background-color: #F3EEEA;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n#restaurantDetailContainer h3 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n  color: #333333;\n}\n\n#restaurantDetailContainer p {\n  font-size: 1rem;\n  margin-bottom: 15px;\n  color: #555555;\n}\n\n#restaurantDetailContainer img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n\n.card {\n  background-color: #F3EEEA;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin-top: 20px;\n}\n\n.card h3 {\n  margin-bottom: 10px;\n  font-size: 1.5rem;\n  color: #333333;\n}\n\n.menu-list,\n.review-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.menu-list li,\n.review-list li {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #EBE3D5;\n  padding-bottom: 5px;\n}\n\n.review-list li:last-child {\n  border-bottom: none;\n}\n#reviewForm {\n  background-color: #FFFFFF;\n  border: 2px solid #B0A695;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n#reviewForm h3 {\n  margin-bottom: 15px;\n  color: #333;\n}\n\n#reviewForm input[type=\"text\"],\n#reviewForm textarea {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 10px;\n  border: 1px solid #B0A695;\n  border-radius: 4px;\n  box-sizing: border-box;\n  font-size: 16px;\n}\n\n#reviewForm textarea {\n  height: 100px;\n  resize: vertical;\n}\n\n#reviewForm button[type=\"submit\"] {\n  background-color: #B0A695;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n#reviewForm button[type=\"submit\"]:hover {\n  background-color: #8A7F6F;\n}\n\n\n.review-list {\n  list-style: none;\n  padding: 0;\n  margin: 20px 0 0 0;\n}\n\n.review-list li {\n  background-color: #FFFFFF;\n  border: 1px solid #B0A695;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.review-list li::before {\n  content: '•';\n  color: #B0A695;\n  font-weight: bold;\n  display: inline-block; \n  width: 1em;\n  margin-left: -1em;\n}\n\n\n.card-detail, .card-detail-rev {\n  background-color: #F3EEEA;\n  border: 3px solid #B0A695;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: inline-block;\n  vertical-align: top;\n  margin: 20px;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.menu {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 20px;\n}\n\n.menu h3 {\n  grid-column: span 2;\n}\n\n.menu ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.menu li {\n  margin-bottom: 10px;\n}\nheader{\n  background-color: #776B5D;\n}\n\n\n\nfooter{\n  display: flex;\n  color: #F3EEEA;\n  justify-content: space-around;\n  text-align: center;\n  align-items: center;\n  height: 55px;\n  background-color: #776B5D;\n}\n\na{\n color: #F3EEEA;\n}\n\nbody{\n  font-family: \"Rubik\", sans-serif;\n  background-color: #B0A695;\n}\n\na, button, input[type=\"submit\"], input[type=\"button\"] {\n  min-width: 44px;\n  min-height: 44px;\n  margin: 10px;\n}\n\n.navbar { \n  min-height: 70px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n}\n\n.logo{\n  color: #F3EEEA;\n  text-shadow:2px 2px 3px #B0A695;\n  font-family: \"Pacifico\", cursive;\n  letter-spacing: 3px;\n}\n\n.nav-menu{\n  display: flex;\n  justify-content: space-between;\n  align-self: center;\n  gap: 60px;\n\n}\n\n.nav-link{\n  transition: 0.5s ease;\n  width: 74px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.nav-link:hover{\n  color: #0c0c0c;\n}\n\n#Bforom { \n  width: 90px;\n  height: 44px;\n  background-color: #776B5D; \n  color: #ffffff; \n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  font-size: 24px;\n  padding: 8px;\n  cursor: pointer;\n  color: white;\n\n  &:hover {\n    color: #ccc;\n  }\n}\n\n.bar {\n  display: block;\n  width: 28px;\n  height: 3px;\n  margin: 5px auto;\n  border-radius: 3px;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background-color: rgb(11, 11, 11);\n}\n\n.hero {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  height: 100vh;\n}\n\n.hero img {\n  width: 100%; \n  height: 100%; \n  object-fit: cover;\n}\n\n@media (min-width: 1200px) {\n  .hero img {\n    min-width: 1000px; \n  }\n}\n\n\n\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background-color: #776B5D ;\n  color: white;\n  padding: 8px;\n  z-index: 100;\n}\n \n.skip-link:focus {\n   top: 0;\n   background-color: #B0A695 ;\n}\n\n.hero-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  text-shadow: 3px 3px 4px #0b0b0b;\n  color: rgb(255, 255, 255);\n  padding: 0 20px\n}\n\n.hero-text h2 {\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n}\n\n.hero-text p {\n  font-size: 1.2rem;\n}\n\n.linkResto{\n  display: inline-block;\n  padding: 6px 12px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.link:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n\n.loading {\n  display: none;\n  text-align: center;\n  font-size: 20px;\n  color: #030303;\n  margin-top: 20px;\n}\n\n\n.error {\n  display: none;\n  text-align: center;\n  font-size: 18px;\n  color: red;\n  margin-top: 20px;\n}\n\n.loading .ri-loader-4-line {\n  font-size: 2rem;\n  display: block;\n  margin: 0 auto;\n  animation: spin 1s linear infinite;\n}\n\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
